import { techDocs } from "../technical-docs";

export default techDocs('tech_manuals', 'Manuais Técnicos', 'documentos-tecnicos-manuais-tecnicos')